import React from 'react'
import { bool, func, string } from 'prop-types'
import styled from 'styled-components'

import { H4 } from 'styles/typography'
import Modal, { ModalSection } from 'components/Modal'
import Button from 'components/button/Button'
import ButtonGroup from 'components/button/ButtonGroup'
import { NativeAuthConsumer } from 'components/NativeAuth'

const Inner = styled.div`
  text-align: center;
`

const CancelSubscriptionModal = ({ visible, close }) => {
  return (
    <Modal visible={visible} close={close}>
      <ModalSection>
        <Inner>
          <H4>Cancel subscription</H4>
          <p>Are you sure you want to cancel your recurring subscription? This action cannot be undone.</p>
          <NativeAuthConsumer>
            {({ setCancelSubscriptionModalVisibility, cancelSubscription, token }) => {
              return (
                <ButtonGroup>
                  <Button
                    onClick={() => {
                      cancelSubscription({ token })
                      setCancelSubscriptionModalVisibility(false)
                    }}
                    theme="negative"
                  >
                    Yes, cancel
                  </Button>
                  <Button
                    onClick={() => {
                      setCancelSubscriptionModalVisibility(false)
                    }}
                    theme="secondary"
                  >
                    No, return
                  </Button>
                </ButtonGroup>
              )
            }}
          </NativeAuthConsumer>
        </Inner>
      </ModalSection>
    </Modal>
  )
}

CancelSubscriptionModal.propTypes = {
  visible: bool.isRequired,
  subscriptionId: string,
  close: func.isRequired
}

export default CancelSubscriptionModal
